define.alias("shared/components/shared/upgrade/feature", "media/components/shared/upgrade/feature");